import { lazy, Suspense } from "react";

import { SiteHeader } from "@/components/siteHeader";
import { GlassScene } from "@/components/glassScene";
import { SideNav } from "@/components/sideNav";
import { MascotIntro, MascotBuddy } from "@/components/mascot";

import { IspHero } from "./sections/hero";
import { IspTrust } from "./sections/trust";
import "./styles.scss";

const SIDE_NAV_ITEMS = [
  { id: "inicio", label: "Início" },
  { id: "integracoes", label: "Integrações" },
  { id: "simulador", label: "Monte seu app" },
  { id: "telas", label: "Telas do app" },
  { id: "beneficios", label: "Benefícios" },
  { id: "como-funciona", label: "Como funciona" },
  { id: "planos", label: "Planos" },
  { id: "faq", label: "FAQ" },
];

// Keep the live app-preview simulator from the original build — it already
// does theme choice + live colour customisation + result carousel.
import { NextLevel } from "@/pages/home/sections/next-level";
const NextLevelTwoStep = lazy(() =>
  import("@/pages/home/sections/next-level-two-step").then((m) => ({
    default: m.NextLevelTwoStep,
  }))
);
const NextLevelResult = lazy(() =>
  import("@/pages/home/sections/next-level-result").then((m) => ({
    default: m.NextLevelResult,
  }))
);

const IspIntegrations = lazy(() =>
  import("./sections/integrations").then((m) => ({ default: m.IspIntegrations }))
);
const IspAppScreens = lazy(() =>
  import("./sections/appScreens").then((m) => ({ default: m.IspAppScreens }))
);
const IspBenefits = lazy(() =>
  import("./sections/benefits").then((m) => ({ default: m.IspBenefits }))
);
const IspHowItWorks = lazy(() =>
  import("./sections/howItWorks").then((m) => ({ default: m.IspHowItWorks }))
);
const IspPlans = lazy(() =>
  import("./sections/plans").then((m) => ({ default: m.IspPlans }))
);
const IspGuarantee = lazy(() =>
  import("./sections/guarantee").then((m) => ({ default: m.IspGuarantee }))
);
const IspFaq = lazy(() =>
  import("./sections/faq").then((m) => ({ default: m.IspFaq }))
);
const SiteFooter = lazy(() =>
  import("@/components/siteFooter").then((m) => ({ default: m.SiteFooter }))
);

export const IspPage = () => {
  return (
    <div className="isp-page">
      <GlassScene variant="isp" />
      <MascotIntro variant="isp" />
      <SiteHeader variant="isp" />
      <SideNav variant="isp" items={SIDE_NAV_ITEMS} />

      <main className="isp-page__main">
        <IspHero />
        <IspTrust />

        <Suspense fallback={null}>
          <IspIntegrations />
        </Suspense>

        <section id="simulador" className="isp-page__simulator">
          <NextLevel />
          <Suspense fallback={null}>
            <NextLevelTwoStep />
            <NextLevelResult />
          </Suspense>
        </section>

        <Suspense fallback={null}>
          <IspAppScreens />
          <IspBenefits />
          <IspHowItWorks />
          <IspPlans />
          <IspGuarantee />
          <IspFaq />
          <SiteFooter variant="isp" />
        </Suspense>
      </main>

      <MascotBuddy variant="isp" />
    </div>
  );
};
